import React from "react";
import { Col, Row } from "react-bootstrap";

const Tab1 = (props)=>{
    const {next} = props;
    return(<>
    <p><span className="highlighted-text">Welcome to StockHero</span>, the trusted automated stock trading software used by thousands around the globe! We're excited to have you on board. To help you get started, we've created a simple 4-step Quick Start guide. By the end of it, you'll have your very first trading bot up and running on our risk-free paper exchange — and don't worry, you can always modify or delete it later if needed. Let’s get trading!</p>
     <br></br>
     {/* <h3>Step 1: Connect Your Brokerage (optional)</h3> */}
     <br/>
        <p className="mb-110">You may link your brokerage account whenever you are ready to start live trading.</p>
        {/* <p>Please go to our <a href="/setting?loc=3" className="link"><b>Brokerage API</b></a> page to add your brokerage. After you have added your brokerage, return to this Quick Start wizard.</p> */}
        <br/>
        <ul className="d-flex justify-content-end w-100">
            {/* <li><a  className="qtrblue-btn pointer" onClick={next}>I have connected StockHero to my exchange</a></li> */}
            <li><a  className="qtrtrans-btn pointer" onClick={next}>Let's Go!</a></li>
        </ul>
    </>)
}
export default Tab1;